module.exports = __webpack_public_path__ + "img/1018492811.9f6dbae5.png";